<template>
  <div class="c-select-account">
    <Row :gutter="12">
      <Col span="14">
        <select-box
          v-model="keyword"
          :data="data"
          :loading="loading"
          :disabled="value.length >= max"
          title="账号"
          class="c-account"
          @on-select="$emit('on-select', $event)"
        >
          <select-item
            :data="data"
            :keyword="keyword"
            :disabled="value.length >= max"
            @on-child="$emit('on-select', $event)"
            @on-select="$emit('on-select', $event)"
          />
        </select-box>
      </Col>

      <Col span="9" offset="1" class-name="m-result">
        <div class="m-wrap m-box">
          <select-box :max="max" :len="value.length" title="已选账号" clear result @on-clear="$emit('on-clear', { list: data })">
            <div v-for="item in value" :key="item.id" class="c-pop-tip">
              <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
            </div>
          </select-box>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import SelectBox from './select-box'
import SelectItem from './select-item'
export default {
  name: 'selectAccount',
  components: { SelectBox, SelectItem },
  props: {
    value: {
      type: Array,
      required: true
    },
    data: {
      type: Array
    },
    max: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    handleClose(event, id) {
      this.$emit('on-delete', { list: this.data, name: id })
    }
  },
  data() {
    return {
      keyword: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-account {
  width: 100%;
  position: relative;

  .c-account {
    border: 1px solid #e8eaec;
  }

  .m-result {
    min-width: 320px;

    .m-wrap {
      border: 1px solid #e8eaec;
    }

    ::v-deep .c-content {
      height: 412px;
    }

    .c-pop-tip {
      width: 100%;
    }

    .c-tag-item {
      width: 90%;
      margin: 8px 8px 0;
      padding: 2px 6px;
      display: block;
      font-size: 14px;
      height: 28px;
    }
  }
}
</style>
